import React from 'react';
import EditorContainerWrapper from 'components/EditorContainerWrapper';

import BlurTextField from 'components/connectedForm/BlurTextField';
import ValueField from 'components/connectedForm/ValueField';

class TextFieldEditor extends EditorContainerWrapper {
  constructor(props) {
    super(props);
  }

  getEditorComponent = () => {
    if (this.props.checkCellEditable && !this.props.checkCellEditable(this.props.column.key, this.props.rowData)) {
      return ValueField;
    }
    return BlurTextField;
  };

  // Set extra props, such as validation
  // Note, we only set the decimals prop if we have one passed to us.
  getEditorProps = () => {
    let decimals = this.props.column?.options?.format?.decimals ?? this.props.rowMetaData?.options?.format?.decimals;

    if (typeof decimals === 'function') {
      decimals = decimals(this.props.rowData);
    }

    return {
      inGrid: true,
      onBlur: this.handleBlur,
      testId: this.props.testId,
      id: this.props.testId,
      decimals,
    };
  };

  // Overrides EditorContainerWrapper onChange
  // TextField sends change for every character typed, delay commit until blur
  onChange = (e) => {
    this.setState({ currentValue: e.target.value });
  };

  handleBlur = (event) => {
    this.props.onCommit();
  };
}

export default TextFieldEditor;
